import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const {
  REACT_APP_API_KEY,
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET,
  REACT_APP_MESSAGING_SENDER_ID,
  REACT_APP_APP_ID,
  REACT_APP_MEASUREMENT_ID,
} = process.env;

const firebaseConfig = {
  apiKey: REACT_APP_API_KEY,
  authDomain: REACT_APP_AUTH_DOMAIN,
  projectId: REACT_APP_PROJECT_ID,
  storageBucket: REACT_APP_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
  appId: REACT_APP_APP_ID,
  measurementId: REACT_APP_MEASUREMENT_ID,
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const projectsCollection = db.collection('projects');
const projectGroupCollection = db.collection('projectGroup');
const templatesCollection = db.collection('templates');
const timesheetCollectionNew = db.collection('timesheetNew');
// const timesheetCollection = db.collection('timesheets');

const usersCollection = db.collection('users');
const companiesCollection = db.collection('companies');
const contactsCollection = db.collection('contacts');
const actualsCollection = db.collection('actuals');
const rateCardsCollection = db.collection('rateCards');
const servicesCollection = db.collection('services');
const timesheetNewCollection = db.collection('timesheetNew');

// Listen for changes in authentication state
firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    console.log('User is authenticated');
  } else {
    console.log('User is not authenticated');
  }
});

export {
  db,
  projectsCollection,
  projectGroupCollection,
  templatesCollection,
  usersCollection,
  companiesCollection,
  contactsCollection,
  actualsCollection,
  servicesCollection,
  rateCardsCollection,
  timesheetNewCollection,
  timesheetCollectionNew,
  // timesheetCollection,
};
